import React, { useState, useEffect } from 'react';
import { Button, Form, Modal } from 'react-bootstrap';
import { IoCloseOutline } from 'react-icons/io5';
import { query, collection, onSnapshot, orderBy } from "firebase/firestore";
import { db } from './../../../firebase';
import './index.css';
import { useAuth } from '../../../context/AuthContext';

function PartyModal({ title, buttonTitle, buttonClass, buttonVariant, buttonSize, handleResponse }) {

  const { user } = useAuth();
  const { bid } = user.claims;

  const [show, setShow] = useState(false);
  const [data, setData] = useState(null);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  function getParties() {
    const q = query(collection(db, "Businesses", bid, "Parties"), orderBy('partyName'));
    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      const tempData = [];
      querySnapshot.forEach((doc) => {
        tempData.push({ id: doc.id, ...doc.data() });
      });

      setData(tempData);
    }, (error) => {
      console.log(error.message);
    });

    return () => unsubscribe;
  }

  useEffect(() => {
    getParties();
  }, []);

  function handleSelectData(item) {
    handleResponse(item);
    handleClose();
  }

  function handleCloseData() {
    handleClose();
    handleResponse();
  }

  return (
    <>
      <Button variant={buttonVariant} size={buttonSize} className={buttonClass} onClick={handleShow}>
        {buttonTitle ? buttonTitle : 'Button'}
      </Button>

      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        size='xl'
        dialogClassName="modal-wrapper"
        contentClassName="modal-custom-content overflow-hidden"
        centered
      >
        <div className='modal-head'>
          <h5>{title ? title : '{Your Title}'}</h5>
          <Button
            variant='link'
            size='sm'
            className='text-dark p-1 rounded'
            onClick={() => {
              handleCloseData();
            }}
          >
            <IoCloseOutline size={24} />
          </Button>
        </div>
        <div className='row my-3 px-3'>
          <div className='col-md-12'>
            <Form.Group>
              <Form.Control
                placeholder='Search party by name or number'
                className='bg-light'
              />
            </Form.Group>
          </div>
        </div>
        <div className='overflow-scroll'>
          <table className="table table-hover mb-0">
            <thead className='table-thead sticky-top'>
              <tr className='border-top border-bottom'>
                <th className='text-secondary bg-light fw-normal p-3 align-middle text-center'><small>#</small></th>
                <th className='text-secondary bg-light fw-normal p-3 align-middle'><small>Party Name</small></th>
                <th className='text-secondary bg-light fw-normal p-3 align-middle'><small>Father/Husband</small></th>
                <th className='text-secondary bg-light fw-normal p-3 align-middle text-center '><small>Phone Number</small></th>
                <th className='text-secondary bg-light fw-normal p-3 align-middle text-end '><small>State</small></th>
              </tr>
            </thead>
            <tbody>
              {
                data && data.map((item, index) => {
                  return (
                    <tr
                      key={index}
                      className='border-bottom cursor-pointer'
                      onClick={() => handleSelectData(item)}
                    >
                      <td className='p-3 align-middle text-center'>{index + 1}</td>
                      <td className='p-3 align-middle'>{item.partyName}</td>
                      <td className='p-3 align-middle'>{item.fatherHusband}</td>
                      <td className='p-3 align-middle text-center'>+91 {item.phoneNumber}</td>
                      <td className='p-3 align- text-end'>{item.state}</td>
                    </tr>
                  )
                })
              }
            </tbody>
          </table>
        </div>
      </Modal>
    </>
  );
}

export default PartyModal;
